<template>
  <div>{{ publishTime }}</div>
</template>

<script>
export default {
  props: ['value', 'field', 'xprops'],
  data() {
    return {}
  },
  computed: {
    publishTime() {
      return this.value.substring(0, 10)
    }
  },
}
</script>

<style lang="less" scoped>
</style>